export enum PolicyAdjustmentPath {
  Section = 'section/:sectionId',
  Adjustment = 'adjustment/:adjustmentId',
}
